import { render, staticRenderFns } from "./bodyProduct.vue?vue&type=template&id=45ae2f98&scoped=true&"
import script from "./bodyProduct.vue?vue&type=script&lang=js&"
export * from "./bodyProduct.vue?vue&type=script&lang=js&"
import style0 from "./bodyProduct.vue?vue&type=style&index=0&id=45ae2f98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ae2f98",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VCol,VRow,VSnackbar})
